"use client";
import React from "react";
import { useTranslation } from "react-i18next";
import { GoPeople } from "react-icons/go";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { CiLocationOn } from "react-icons/ci";

export default function Terms() {
  const { t } = useTranslation();
  return (
    <div>
      {/* <Header /> */}
      <div className="">
        <div className="grid gap20 p20">
          <h1 className="f40">{t("terms")} </h1>
          <div className=" grid gap20 mc1">
           
            <UIItem
              title={t("who_we_are")}
              content={<>{t("servwho_we_are_descriptionice_1")}</>}
              icon={<GoPeople size={20} color="#fff" />}
            />

            <div className="c2 gap10 mc1">
              <UIItem
                title={t("our_services")}
                content={
                  <>
                    <p className="">{t("service_1")}</p>
                    <p className="">{t("service_2")}</p>
                  </>
                }
                icon={<MdOutlineSettingsSuggest size={20} color="#fff" />}
              />
              <UIItem
                title={t("our_location")}
                content={<>{t("location")}</>}
                icon={<CiLocationOn size={20} color="#fff" />}
              />
            </div>
          </div>
          <div className="grid gap20">
            <h2 className="light-blue f30">{t("import_policy")}</h2>
            <div className="grid gap10">
              <p>1 - {t("policy_1")}</p>
              <p>2 - {t("policy_2")}</p>
              <p>3 - {t("policy_3")}</p>
              <p>4 - {t("policy_4")}</p>
              <p>5 - {t("policy_5")}</p>

              <p>6 - {t("policy_6")}</p>
              <p>7 - {t("policy_7")}</p>
              <p>8 - {t("policy_8")}</p>
              <p>9 - {t("policy_9")}</p>
              <p>10 - {t("policy_10")}</p>
              <p>11 - {t("policy_11")}</p>
            </div>
          </div>

          <div className="grid gap20">
            <h2 className="light-blue">{t("prohibited_goods")}</h2>
            <div className="flex gap10" style={{ flexWrap: "wrap" }}>
              <UIItem2 text={t("prohibited_1")} />
              <UIItem2 text={t("prohibited_2")} />
              <UIItem2 text={t("prohibited_3")} />
              <UIItem2 text={t("prohibited_4")} />
              <UIItem2 text={t("prohibited_5")} />
              <UIItem2 text={t("prohibited_6")} />
              <UIItem2 text={t("prohibited_7")} />
              <UIItem2 text={t("prohibited_8")} />
              <UIItem2 text={t("prohibited_9")} />
              <UIItem2 text={t("prohibited_10")} />
              <UIItem2 text={t("prohibited_11")} />
              <UIItem2 text={t("prohibited_12")} />
            </div>
          </div>
          <div className="light-grey-bg br20 p30 grid gap10">
            <h2 className="light-blue  ">{t("note")}</h2>
            <p>{t("note_1")}</p>
            <p className="red f17">{t("note_2")}</p>
            <p>{t("note_3")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const UIItem2 = ({ text }: { text: string }) => {
  return (
    <div className="br10 pl20 pr20 p10 light-grey-bg br-light-blue f15">{}</div>
  );
};

const UIItem = ({
  title,
  content,
  icon,
}: {
  title: string;
  content: JSX.Element;
  icon: JSX.Element;
}) => {
  return (
    <div className="light-grey-bg br20 p30 grid gap10">
      <div className="auto-c1">
        <div className="secondary-color-bg br5 p10 br-light-blue">{icon}</div>
        <div></div>
      </div>
      <h2 className="light-blue">{title}</h2>
      {content}
    </div>
  );
};
